<template>
    <div>
        <b-table
            :empty-text="this.$t('there_are_no_records')"
            bordered
            striped
            responsive
            :items="outOfCountryRequest"
            :fields="outOfCountryRequestField"
            show-empty
            class="mb-5 table-dropdown no-scrollbar border rounded document_request_dropdown">
            <template #cell(file_upload_status)="{item}">
                <b-button v-if="item.status==='waiting_ticket_upload'" variant="primary" @click="openAddFileModal(item.id)">{{$t('ticket') + ' ' + $t('upload')}}</b-button>
            </template>
        </b-table>

        <CommonModal ref="addFileModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="formClear()">
            <template v-slot:CommonModalTitle>
                {{ $t('ticket').toUpper() + ' ' + $t('upload').toUpper() }}
            </template>
            <template v-slot:CommonModalContent>
                <ValidationObserver ref="addFileForm">
                        <div class="d-flex custom-file-upload">
                            <ValidationProvider name="file" rules="required" v-slot="{valid, errors}">
                                <b-form-group :label="$t('upload')">
                                    <div class="d-flex custom-file-upload">
                                        <b-form-file v-model="ticket"
                                                     :state="errors[0] ? false : (valid ? true : null)"
                                                     :placeholder="$t('select_file')"
                                                     :drop-placeholder="$t('drop_file')"
                                                     ref="fileInput"
                                                     accept=".jpg, .jpeg, .png, .pdf"                                        />
                                        <b-button variant="outline-secondary"
                                                  @click="$refs.fileInput.$el.childNodes[0].click();">{{ $t('browse') }}
                                        </b-button>
                                    </div>
                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                </b-form-group>
                            </ValidationProvider>
                        </div>
                </ValidationObserver>
                <div>
                    <ProcessingButton :label="$t('upload')" @click="uploadFile"/>
                </div>
            </template>
        </CommonModal>
    </div>

</template>
<script>
import qs from "qs";
import OutOfCountryMentora from "@/services/OutOfCountryMentoraServices";
import ProcessingButton from "@/components/elements/ProcessingButton.vue";

export default {
    name: "TransferOut",
    components: {ProcessingButton},
    props:{
      filter:{
          type:Object
      }
    },
    data(){
        return {
            formId:null,
            ticket:null,
            outOfCountryRequest: [],
            outOfCountryRequestField: [
                {
                    key: 'student_number',
                    label: this.$t('student_number').toUpper(),
                },
                {
                    key: 'name',
                    label: this.$t('first_name').toUpper(),
                },
                {
                    key: 'surname',
                    label: this.$t('last_name').toUpper(),
                },

                {
                    key: 'estimated_departure_date',
                    label: this.$t('estimated_date_of_departure').toUpper(),
                },
                {
                    key: 'estimated_return_date',
                    label: this.$t('estimated_date_of_return').toUpper(),
                },
                {
                    key: 'status_name',
                    label: this.$t('status').toUpper(),
                },

            ],
        }
    },
    created() {
      this.getData()
    },
    methods:{
        getData(){
            const transferOutRequest = {
                ...this.filter,
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            }
            OutOfCountryMentora.getStudentOutOfRequests(transferOutRequest)
                .then(response => {
                    this.outOfCountryRequest = response.data.data;
                    this.outOfCountryRequest.map((item,key)=>{
                        if (item.status==='waiting_ticket_upload'){
                            this.outOfCountryRequestField.push({
                                key: 'file_upload_status',
                                label: this.$t('file').toUpper(),
                              },
                            )

                        }else {
                            return {
                                ...item,
                                file_upload_status:null
                            }
                        }

                    })
                }).catch(e => {
                this.showErrors(e);
            })

        },
        openAddFileModal(id){
            this.formId=id
            this.$refs.addFileModal.$refs.commonModal.show()
        },
        async uploadFile(){
            const isValid =await this.$refs.addFileForm.validate()
            if(!isValid) return
            try {
                const formData = new FormData();
                formData.append('ticket', this.ticket);
                const res= await OutOfCountryMentora.uploadFile(this.formId,formData)
                this.$toast.success(this.$t('api.' + res.data.message));
                this.$refs.addFileModal.$refs.commonModal.hide()
                this.getData()
            }catch (error) {
                this.showErrors(error,this.$refs.addFileForm)
            }
        }
    }
}
</script>

<style scoped>

</style>
